module.exports = __webpack_public_path__ + "img/freeNode.799d04fe.svg";